export default __webpack_public_path__ + "media/images/more-d7187390.svg";